import { render, staticRenderFns } from "./AppJamstack1.vue?vue&type=template&id=064c2831&scoped=true&"
import script from "./AppJamstack1.vue?vue&type=script&lang=js&"
export * from "./AppJamstack1.vue?vue&type=script&lang=js&"
import style0 from "./AppJamstack1.vue?vue&type=style&index=0&id=064c2831&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c2831",
  null
  
)

export default component.exports